import * as React from 'react';
import { ButtonTertiary } from 'ui';
import { FiChevronDown } from 'react-icons/fi';
import styles from './display-selected-options.scss';

import type { JSX } from "react";

export interface OptionItemSelections {
  titles: string[];
  values: (string | number)[];
  excludedValues: string[];
}

export interface OptionItem {
  value: string;
  label: string;
  selections: OptionItemSelections;
}

interface DisplaySelectedOptionsComponentProps {
  selectedOptions: OptionItem[];
  textHideDetails: string;
  textShowDetails: string;
}

interface DisplaySelectedOptionsComponentState {
  isOverflowing: boolean;
  isExpanded: boolean;
  overflowHeight: number;
}

class DisplaySelectedOptionsComponent extends React.Component<DisplaySelectedOptionsComponentProps, DisplaySelectedOptionsComponentState> {

  private listRef: React.RefObject<HTMLOListElement | null> = React.createRef();

  public state:Readonly<DisplaySelectedOptionsComponentState> = {
    isExpanded: false,
    isOverflowing: false,
    overflowHeight: 0
  };

  private onClick = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    this.setState({
      isExpanded: !this.state.isExpanded
    } as DisplaySelectedOptionsComponentState);
  };

  private setOptionItemValue = (title: string, value: string | number) => {
    const valueWithAdditionalInformation = <>{title} <span className={styles.additionalInformation}>({value})</span></>;
    return <p className={styles.optionItemValue}>{title ? valueWithAdditionalInformation : value}</p>;
  };

  private setExcludedOptionValue = (excludedValues: string[]) => {
    return excludedValues && excludedValues.length > 0 && '(' + excludedValues.join(', ') + ')';
  };

  private renderOptionItem = (item: OptionItem) => {
    return <li key={item.value}>
      <span>{item.label} {this.setExcludedOptionValue(item.selections.excludedValues)}</span>
      <ul className={styles.filtersSelected}>
        {item.selections.values.map((value, i) => <li key={i}>
          {this.setOptionItemValue(item.selections.titles[i], value)}
        </li>)}
      </ul>
    </li>;
  };

  public componentDidUpdate() {
    const list = this.listRef.current;
    if(list) {
      const scrollHeight = list.scrollHeight;

      if (!this.state.isExpanded) {
        const overflowHeight = Math.max(list.offsetHeight, this.state.overflowHeight);
        const isOverflowing = scrollHeight > overflowHeight;

        if (isOverflowing !== this.state.isOverflowing || overflowHeight !== this.state.overflowHeight) {
          this.setState({isOverflowing, overflowHeight});
        }
      } else if (scrollHeight <= this.state.overflowHeight) {
        this.setState({isExpanded: false, isOverflowing: false});
      }
    }
  }

  public render(): JSX.Element {
    const {
      selectedOptions,
      textHideDetails,
      textShowDetails
    } = this.props;
    const {
      isExpanded,
      isOverflowing
    } = this.state;

    const collapseButton = <div className={styles.toggleExpand}><ButtonTertiary onClick={this.onClick}>
      {isExpanded ?
        (textHideDetails)
        : (textShowDetails)}
      <FiChevronDown className={isExpanded ? 'expand-icon-down' : 'expand-icon-up'} />
    </ButtonTertiary></div>;

    return ((selectedOptions.length > 0 &&
      <div className={`${styles.ieMaxWidthFix} ${isExpanded || isOverflowing ? styles.shouldCollapse : ''}`}>
        <ol ref={this.listRef} className={`${styles.filterList} ${isExpanded ? styles.expanded : styles.collapsed}`}>
          {selectedOptions.map((item) => this.renderOptionItem(item))}
        </ol>
        {collapseButton}
        <div className={styles.shadowBox} />
      </div>));
  }
}

export const DisplaySelectedOptions = DisplaySelectedOptionsComponent;
